window.axios = require('axios')

import Vue from 'vue'
import Widget from './../components/widget/Widget'

const config = JSON.parse(atob(window.wbt[0].c))

const WidgetComponent = Vue.extend(Widget)
const instance = new WidgetComponent({
    propsData: {
        copyrightUrl: config.brand.url,
        copyrightName: config.brand.name,
        apiUrl: config.apiUrl,
    }
})
const component = instance.$mount()
document.querySelector('body').appendChild(component.$el)
